import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueCompanyPageEvents } from '../../../types/companyDetail';
import { CompanyDetailEventsChild } from '../../molecules/companyDetailEventsChild';

type Props = {
  eventIds: number[];
  companyId: number;
  coverNoImg: string;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageEvents;
};

export const Presentation: FunctionComponent<Props> = ({
  eventIds,
  companyId,
  coverNoImg,
  dataCategory,
  dataValue,
}) => {
  if (!eventIds || eventIds.length === 0) return null;

  return (
    <section className="company__page__recruitments css-slider" id="events">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">イベント</h2>
        <a
          href={`/companies/${companyId}/events`}
          className="company__page__recruitments__header--link gtm-button-view-count"
          data-event-name='button on screen'
          data-event="click"
          data-category={dataCategory}
          data-value={dataValue.moreSelfEvent}
        >
          すべてのイベントを見る
        </a>
      </div>

      <div className="company__page__recruitments__wrapper slides">
        {eventIds.map((id) => (
          <CompanyDetailEventsChild
            key={id}
            id={id}
            coverNoImg={coverNoImg}
            dataCategory={dataCategory}
            dataValue={dataValue}
          />
        ))}
      </div>
    </section>
  );
};
